import { css, type Theme } from "@emotion/react";

export const error = (theme: Theme) => css`
  color: ${theme.danger.textBase};
  margin-top: 1rem;
  text-align: center;
`;
